import { Router } from '@angular/router';
import { FETCH_COLLECTIONS_REQUESTED } from './../list/list.actions';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {
  ATTACH_PRODUCT_TO_COLLECTION_FAILED,
  EDIT_COLLECTION_REQUESTED,
  EDIT_COLLECTION_SUCCEEDED,
  DELETE_COLLECTION_REQUESTED,
  GET_COLLECTION_REQUESTED,
  GET_COLLECTION_SUCCEEDED,
  ATTACH_PRODUCT_TO_COLLECTION_REQUESTED,
  ATTACH_PRODUCT_TO_COLLECTION_SUCCEEDED,
  SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED,
  SEND_COLLECTION_CONSIGNMENT_AGREEMENT_REQUESTED,
  RESPOND_COLLECTION_SUCCEEDED,
  RESPOND_COLLECTION_REQUESTED,
  SEND_COLLECTION_TO_SHOOT_SUCCEEDED,
  SEND_COLLECTION_TO_SHOOT_REQUESTED,
  SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED,
  SEND_COLLECTION_PICKUP_CONFIRMATION_REQUESTED,
  IMPORT_PRODUCT_FROM_FILE_REQUESTED,
  IMPORT_PRODUCT_FROM_FILE_SUCCEEDED,
  IMPORT_PRODUCT_FROM_FILE_FAILED,
  IMPORT_PRODUCT_FROM_FILE_COMPLETED,
  GET_IMPORT_HISTORIES_SUCCEEDED,
  GET_IMPORT_HISTORIES_REQUESTED,
  SEND_COLLECTION_TO_WAREHOUSE_REQUESTED, SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED
} from './edit.actions';
import { NotificationService } from '../../../common/services/notification/notification.service';
import {FETCH_PRODUCTS_REQUESTED} from "../../product/list/list.actions";
import Redirect from "../../../models/Redirect";
import store from "../../../store/store.module";
import {UtilityService} from "../../../common/services/utility/utility.service";
import {WIZARD_PRODUCT_CREATED} from "../../product/wizard/wizard.actions";

function* updateCollection(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.collection.update(action.data).toPromise();
    yield put({ type: EDIT_COLLECTION_SUCCEEDED, data: result });
    AppInjector.get(NotificationService).show('success', `Successfully update collection`, 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateCollectionRequest() {
  yield takeEvery(EDIT_COLLECTION_REQUESTED, updateCollection);
}

function* attachProductToCollection(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let id = action.data.collectionId;
    let data = Object.keys(action.data).filter(s => ['collectionId', 'force', 'attachedAlert'].indexOf(s)  === -1).reduce((prevValue, currentValue) => {
      prevValue[currentValue] = action.data[currentValue];
      return prevValue;
    }, {});
    let resultCheck = yield api.product.getItemBy('sku', data['sku']).toPromise();
    if (!action.data.force) {
      if (resultCheck.collection_id) {
        action.data.attachedAlert.show();
        return;
      }
    }
    yield api.collection.attachProduct(id, data).toPromise();
    let result = yield api.product.getItemBy('sku', data['sku']).toPromise();
    AppInjector.get(UtilityService).nextPageWithReferer(['product/wizard/1'], new Redirect(action.data.url, {
      id: result.id,
      ...action.data.carryOverData
    }));
  } catch (e) {
    console.log(e);
    yield put({ type: ATTACH_PRODUCT_TO_COLLECTION_FAILED, data: action.data });
  }
}

function* watchAttachProductToCollectionRequest() {
  yield takeEvery(ATTACH_PRODUCT_TO_COLLECTION_REQUESTED, attachProductToCollection);
}

function* attachProductToCollectionFailed(action) {
  if (!action.data.sku) {
    AppInjector.get(NotificationService).show('warning', `Sku not found`, 1000);
  }
}

function* watchAttachProductToCollectionFailed() {
  yield takeEvery(ATTACH_PRODUCT_TO_COLLECTION_FAILED, attachProductToCollectionFailed);
}

function* deleteCollection(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.collection.delete(action.data).toPromise();
    router.navigate(['collection']);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteCollectionRequest() {
  yield takeEvery(DELETE_COLLECTION_REQUESTED, deleteCollection);
}

function* getCollection(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.collection.getItemByIdWithProducts(action.data).toPromise();
    yield put({ type: GET_COLLECTION_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetCollectionRequest() {
  yield takeEvery(GET_COLLECTION_REQUESTED, getCollection);
}

function* sendCollectionToShoot(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.collection.sendCollectionToShoot(action.data.id).toPromise();
    yield put({ type: SEND_COLLECTION_TO_SHOOT_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendCollectionToShootRequested() {
  yield takeEvery(SEND_COLLECTION_TO_SHOOT_REQUESTED, sendCollectionToShoot);
}

function* sendCollectionToShootSucceeded(action) {
  try {
    AppInjector.get(NotificationService).show('success', `Successfully sent collection to shoot`, 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendCollectionToShootSucceeded() {
  yield takeEvery(SEND_COLLECTION_TO_SHOOT_SUCCEEDED, sendCollectionToShootSucceeded);
}


function* sendCollectionToWarehouse(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.collection.sendCollectionToWarehouse(action.data.id).toPromise();
    yield put({ type: SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendCollectionToWarehouseRequested() {
  yield takeEvery(SEND_COLLECTION_TO_WAREHOUSE_REQUESTED, sendCollectionToWarehouse);
}

function* sendCollectionToWarehouseSucceeded(action) {
  try {
    AppInjector.get(NotificationService).show('success', `Successfully sent collection to warehouse`, 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendCollectionToWarehouseSucceeded() {
  yield takeEvery(SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED, sendCollectionToWarehouseSucceeded);
}


function* sendConsigmentAgreement(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.collection.sendConsigmentAgreement(action.data.id).toPromise();
    yield put({ type: SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendConsigmentAgreementRequest() {
  yield takeEvery(SEND_COLLECTION_CONSIGNMENT_AGREEMENT_REQUESTED, sendConsigmentAgreement);
}

function* sendConsigmentAgreementSucceeded(action) {
  try {
    AppInjector.get(NotificationService).show('success', `Successfully sent consigment agreement`, 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendConsigmentAgreementSucceeded() {
  yield takeEvery(SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED, sendConsigmentAgreementSucceeded);
}

function* responseCollectionRequest(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.collection.responseCollection(action.data.id, action.data.response, action.data.fasttrack).toPromise();
    yield put({ type: RESPOND_COLLECTION_SUCCEEDED, data: result, request: action.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchResponseCollectionRequest() {
  yield takeEvery(RESPOND_COLLECTION_REQUESTED, responseCollectionRequest);
}

function* responseCollectionSucceeded(action) {
  try {
    AppInjector.get(NotificationService)
      .show('success', `Successfully ${action.request.response ? 'Approve' : 'Reject'} Collection`, 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchResponseCollectionSucceeded() {
  yield takeEvery(RESPOND_COLLECTION_SUCCEEDED, responseCollectionSucceeded);
}

function* sendPickupConfirmationRequested(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.collection.sendPickupConfirmation(action.data.id).toPromise();
    yield put({ type: SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendPickupConfirmationRequest() {
  yield takeEvery(SEND_COLLECTION_PICKUP_CONFIRMATION_REQUESTED, sendPickupConfirmationRequested);
}

function* sendPickupConfirmationSucceeded(action) {
  try {
    AppInjector.get(NotificationService).show('success', `Successfully sent pickup confirmation`, 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendPickupConfirmationSucceeded() {
  yield takeEvery(SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED, sendPickupConfirmationSucceeded);
}

function* getImportHistory(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.asyncProcess.getAllImportProducts(`"collection_id":"${action.data}"`).toPromise();
    yield put({ type: GET_IMPORT_HISTORIES_SUCCEEDED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetImportHistoriesRequested() {
  yield takeEvery(GET_IMPORT_HISTORIES_REQUESTED, getImportHistory);
}

function* importFromCsvRequested(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.importFromCsv(action.data, action.file).toPromise();
    yield put({ type: IMPORT_PRODUCT_FROM_FILE_COMPLETED, data: result.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchImportFromCsvRequested() {
  yield takeEvery(IMPORT_PRODUCT_FROM_FILE_REQUESTED, importFromCsvRequested);
}

function* importFromCsvFailed(action) {
  AppInjector.get(NotificationService).show('warning', action.message, 5000);
}

function* watchImportFromCsvFailed() {
  yield takeEvery(IMPORT_PRODUCT_FROM_FILE_FAILED, importFromCsvFailed);
}

function* importFromCsvSuccessed(action) {
  AppInjector.get(NotificationService).show('success', `Successfully import products to collection`, 5000);
}

function* watchImportFromCsvSuccessed() {
  yield takeEvery(IMPORT_PRODUCT_FROM_FILE_SUCCEEDED, importFromCsvSuccessed);
}

export default [
  watchUpdateCollectionRequest,
  watchDeleteCollectionRequest,
  watchGetCollectionRequest,
  watchAttachProductToCollectionRequest,
  watchAttachProductToCollectionFailed,
  watchSendConsigmentAgreementRequest,
  watchSendConsigmentAgreementSucceeded,
  watchResponseCollectionSucceeded,
  watchResponseCollectionRequest,
  watchSendCollectionToShootRequested,
  watchSendCollectionToShootSucceeded,
  watchSendPickupConfirmationRequest,
  watchSendPickupConfirmationSucceeded,
  watchImportFromCsvRequested,
  watchImportFromCsvFailed,
  watchImportFromCsvSuccessed,
  watchGetImportHistoriesRequested,
  watchSendCollectionToWarehouseSucceeded,
  watchSendCollectionToWarehouseRequested
];
